import { Link, useLocation } from "react-router-dom";
import { User, Building2, ArrowRight } from "lucide-react";

export default function Register() {
  const loc = useLocation();
  const search = loc.search || "";
  return (
    <div className="container mx-auto px-4 md:px-8 py-16 max-w-md">
      <p className="overline mb-2">Inscription</p>
      <h1 className="font-display text-4xl font-black tracking-tight text-ink">Créer un compte</h1>
      <p className="mt-2 text-subtle">Choisissez le type de compte que vous souhaitez créer.</p>

      <div className="mt-10 space-y-3" data-testid="auth-chooser">
        <Link
          to="/search"
          className="group flex items-center gap-4 border-2 border-brand p-5 hover:bg-surface transition-colors"
          data-testid="chooser-visitor-btn"
        >
          <div className="flex h-12 w-12 items-center justify-center bg-brand text-white">
            <User size={22} />
          </div>
          <div className="flex-1">
            <p className="overline text-brand">Visiteur</p>
            <p className="font-display text-xl font-bold text-ink">Accéder à une file d'attente</p>
            <p className="text-xs text-subtle mt-1">Prendre un ticket à distance</p>
          </div>
          <ArrowRight className="text-brand transition-transform group-hover:translate-x-1" />
        </Link>

        <Link
          to="/commerce/register"
          className="group flex items-center gap-4 border-2 border-ink p-5 hover:bg-surface transition-colors"
          data-testid="chooser-establishment-btn"
        >
          <div className="flex h-12 w-12 items-center justify-center bg-brand text-white">
            <Building2 size={22} />
          </div>
          <div className="flex-1">
            <p className="overline text-ink">Établissement</p>
            <p className="font-display text-xl font-bold text-ink">Créer et gérer ma file d'attente</p>
          </div>
          <ArrowRight className="text-ink transition-transform group-hover:translate-x-1" />
        </Link>
      </div>

      <p className="mt-8 text-sm text-subtle">
        Déjà un compte ? <Link to={`/login${search}`} className="text-brand font-medium">Se connecter</Link>
      </p>
    </div>
  );
}
